import React from "react";
import { useRecordContext, useTranslate } from "react-admin";
import Typography from "@mui/material/Typography";

type Props = {
  source: string;
  fromDeal?: boolean;
};

export const getShunDateString = (value: string | null | undefined, translate?: any, nullTranslate: boolean = true) => {
  const translator = translate ? translate : useTranslate();
  if (value === undefined) {
    return null;
  }

  if (value === null) {
    if (nullTranslate) {
      return translator("ui.value.shun_date_not_set");
    } else {
      return null;
    }
  }

  const [year, month, day] = value.split("-");
  let shun = "";
  switch (day) {
    case "01":
      shun = translator("ui.value.early");
      break;
    case "11":
      shun = translator("ui.value.mid");
      break;
    case "21":
      shun = translator("ui.value.late");
      break;
  }

  return `${year}年${month}月${shun}`;
};

export const HarvestPlanField = (props: Props) => {
  const record = useRecordContext();
  const { source, fromDeal } = props;
  const translate = useTranslate();
  if (!record) {
    return null;
  }

  let value = null;
  if (!fromDeal && record["amend"]) {
    value = record["amend"][source];
  } else {
    value = record[source];
  }

  return <Typography variant="body2">{getShunDateString(value, translate)}</Typography>;
};
